window.BlazeSDK = window.BlazeSDK || {};

window.breeze = window.breeze || {};

window.breeze.onCheckoutButtonClick = async (props) => {
  if (props !== null) {
    try {
      const res = await onProductPage(props);
      return res;
    } catch (e) {
      console.error("Exception: ", e);
    }
  }
  return {
    checkoutFlag: true,
    offerCode: "nothing",
    platformCustomerId: getCustomerIdFromLocalStorage(),
  };
};

function getCustomerIdFromLocalStorage() {
  var customerId = localStorage.getItem("platformCustomerId");
  if (customerId) {
    return customerId;
  } else {
    return null;
  }
}

async function onProductPage(props) {
  try {
    const decodedProps = atob(props);
    const jsonProps = JSON.parse(decodedProps);
    const cartItems = jsonProps !== null ? [jsonProps] : [];
    if (cartItems !== null && cartItems.length > 0) {
      return {
        checkoutFlag: true,
        offerCode: "nothing",
        platformCustomerId: getCustomerIdFromLocalStorage(),
      };
    }
  } catch (e) {
    console.error("Breeze| Exception| onProductPage: ", e);
  }
  return false;
}
